import React from "react";
import { ThemeProvider, Theme, StyledEngineProvider } from "@mui/material";
import CssBaseline from "@mui/material/CssBaseline";
import { usePublicLayoutStyle } from "./PublicLayout.style";
import { publicTheme } from "../themes/public.theme";

declare module "@mui/styles/defaultTheme" {
    // eslint-disable-next-line @typescript-eslint/no-empty-interface
    interface DefaultTheme extends Theme {}
}

export const PublicLayout: React.FC<{ children?: React.ReactNode }> = ({ children }): React.ReactElement => {
    const classes = usePublicLayoutStyle();
    return (
        <StyledEngineProvider injectFirst>
            <ThemeProvider theme={publicTheme}>
                <CssBaseline />
                <div className={classes.root}>
                    <main className={classes.main}>{children}</main>
                </div>
            </ThemeProvider>
        </StyledEngineProvider>
    );
};
